import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('comments');
export const ADD_CLAIM_COMMENTS = getActionName('ADD_CLAIM_COMMENTS');
